import { HttpMethods, makeRequest } from "../helpers/http.helper";
import {
  CreatePreSignedUrlRequest,
  CreatePreSignedUrlResponse,
  DeleteUploadResponse,
  FileExtension,
  FileType,
  PlaybackUrlResponse,
  WorkoutAssetListResponse,
} from "../types/upload.type";

export const generatePresignedUrl = (
  data: CreatePreSignedUrlRequest,
  fileExtension: FileExtension
): Promise<CreatePreSignedUrlResponse> => {
  return makeRequest({
    url: "/upload",
    method: HttpMethods.POST,
    data,
    params: {
      file_type: FileType.WORKOUT_VIDEO,
      file_extension: fileExtension,
    },
  });
};

export const getPlaybackUrl = (filePath: string): Promise<PlaybackUrlResponse> => {
  return makeRequest({
    url: "/upload/playback",
    method: HttpMethods.GET,
    params: {
      file_path: filePath,
    },
  });
};

export const deleteUpload = (assetId: string): Promise<DeleteUploadResponse> => {
  return makeRequest({
    url: `/upload/${assetId}`,
    method: HttpMethods.DELETE,
  });
};

export const listWorkoutAssets = async (): Promise<WorkoutAssetListResponse> => {
  const response = await makeRequest({
    url: "/upload/assets",
    method: HttpMethods.GET,
    params: {
      file_type: FileType.WORKOUT_VIDEO,
    },
  });
  return (response?.result ?? response) as WorkoutAssetListResponse;
};

const VIDEO_CONTENT_TYPES: Partial<Record<FileExtension, string>> = {
  [FileExtension.MP4]: "video/mp4",
  [FileExtension.WEBM]: "video/webm",
  [FileExtension.MOV]: "video/quicktime",
};

export const uploadFileToPresignedUrl = async (
  file: File,
  presignedUrl: string,
  extension: FileExtension
): Promise<void> => {
  const response = await fetch(presignedUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type || VIDEO_CONTENT_TYPES[extension] || `video/${extension}`,
    },
    body: file,
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `MinIO upload failed: ${response.status} ${response.statusText}${errorText ? ` - ${errorText}` : ""}`
    );
  }
};
